import React from 'react';

import styles from './NotFound.scss';

const NotFound = () => (
  <div className={styles.error}>
    Page not found
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.js